// src/components/postAd/SubmitAd.js
import { db, auth, storage } from '../../firebase';
import { collection, addDoc, serverTimestamp, doc, updateDoc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import imageCompression from 'browser-image-compression';
import { getCategoryBreadcrumbs } from '../../utils/categoryMapper';
import { createNotification } from '../../services/NotificationService';

export const submitAdToFirebase = async (contextData) => {
  const { photos, adData, selectedCategory, selectedSubCategory, location } = contextData;
  const user = auth.currentUser;

  if (!user) throw new Error("Authentication required");

  // 1. Compress and Upload Photos
  const photoItems = [];
  for (let i = 0; i < photos.length; i++) {
    const file = photos[i];
    
    // Web Compression
    const options = { maxSizeMB: 0.4, maxWidthOrHeight: 1280 };
    const compressed = await imageCompression(file, options);
    
    const fileName = `listing_${Date.now()}_${i}.jpg`;
    const storageRef = ref(storage, `listings/${user.uid}/${fileName}`);
    
    const snapshot = await uploadBytes(storageRef, compressed);
    const url = await getDownloadURL(snapshot.ref);
    
    // Match your PhotoItem model { full, thumb }
    photoItems.push({ full: url, thumb: url });
  }

  const finalDoc = {
    ...adData,
    userId: user.uid,
    status: 'active',
    title: adData.title,
    description: adData.description,
    price: parseInt(adData.price),
    category: getCategoryBreadcrumbs(selectedCategory, selectedSubCategory).categoryTitle,
    subCategory: getCategoryBreadcrumbs(selectedCategory, selectedSubCategory).subCategoryTitle,
    photos: photoItems,
    locationData: location,
    latitude: location.latitude,
    longitude: location.longitude,
    createdAt: serverTimestamp(),
    isAiListing: contextData.flowType === 'AI',
    viewCount: 0,
    adType: 'test',
  };

  // 3. Write to Firestore
  const docRef = await addDoc(collection(db, 'listings'), finalDoc);

  // 4. Create Notification
  await createNotification({
    userId: user.uid,
    type: 'ad_posted',
    title: 'Ad Posted Successfully',
    message: `Your ad "${adData.title}" is now live.`,
    adId: docRef.id,
    adTitle: adData.title
  });

  return docRef.id;
};

export const updateAdInFirebase = async (adId, updatedData) => {
  try {
    const adRef = doc(db, 'listings', adId);
    await updateDoc(adRef, {
      ...updatedData,
      updatedAt: serverTimestamp(),
    });
    return true;
  } catch (error) {
    console.error("Update Error:", error);
    throw error;
  }
};